import { useAuth0 } from "@auth0/auth0-react";
import BackSvgComponent from "assets/icons/svg/back";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import { InputField, LabelField, MyCheckbox } from "components";
import { TextareaField } from "components/TextareaField";
import { useSearch } from "hook";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import Select, { components } from "react-select-v2";
import { emailValidation } from "utils/validation";

const TributeInformation = ({ formik,index }) => {
  const [loading, setLoading] = React.useState(false);
  const [search, setSearch] = useState("");
  const { searchAction } = useSearch({ action: setSearch });
  // const [data, setData] = useState();
  const { getAccessTokenSilently } = useAuth0();

  const enableLoading = (value) => {
    setLoading(value);
  };

  const payNowValueData = useSelector(
    (state) => state.homeReducer.payNowValueData
  );

  const selectControlStyles = {
    backgroundColor: "#F3F6F9",
    borderColor: "#F3F6F9",
    color: "#3F4254",
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
    paddingTop: "6px",
    paddingBottom: "6px",
    cursor: "pointer",
  };
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      ...selectControlStyles,
    }),
  };
  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <BottomArrowSvg label="Emoji" />
      </components.DropdownIndicator>
    );
  };
  const formatOptionLabel = ({ label, account_id }) => {
    return (
      <div className="dropdown-container" key={account_id}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{label}</div>
          </div>
        </div>
      </div>
    );
  };


  const addRecipientHandler = () => {
    const error = formik?.values?.values?.[index]?.acknowledgements?.some((item) => {
      if (!item?.recipient_name) {
        toastr.info("validation error", "Donation Recipient Name is required");
        return true;
      }

      if (!item?.email) {
        toastr.info("validation error", "Email is required");
        return true;
      }

      if (!emailValidation(item?.email)) {
        toastr.info("validation error", "Email is not valid");
        return true;
      }
    });


    if (error) {
      return;
    }

    formik.setFieldValue(`values.${index}.acknowledgements`, [
      ...formik?.values?.values?.[index]?.acknowledgements,
      {
        recipient_name: "",
        email: "",
      },
    ]);
  };



  const deleteRecipientHandler = (acknowledgementIndex) => {
    if (formik?.values?.values?.[index]?.acknowledgements?.length === 1) {
      return toastr.info("validation error", "At least one recipient is required");
    }
    const updatedAcknowledgements = formik?.values?.values?.[index]?.acknowledgements.filter(
      (item, index) => index !== acknowledgementIndex
    );
    
    formik.setFieldValue(`values.${index}.acknowledgements`, updatedAcknowledgements);
  }


  return (
    <div className="">
      <form
        onSubmit={formik?.handleSubmit}
        className="form fv-plugins-bootstrap fv-plugins-framework"
      >
        <div className=" col-sm-12 pt-5 pb-5 tribute-info__wrapper">
        <Row className="form-row sm-12 ">
            <Col className="col-12 col-md-6  tribute-text">
              <LabelField title="Tribute Type" 
                mandatory={true}
              />
              <Select
                {...{
                  formik,
                  name: `tribute_type`,
                  checkValidation: true,
                }}
                onInputChange={(text) => searchAction(text)}
                classNamePrefix="react-select"
                formatOptionLabel={formatOptionLabel}
                options={[
                  { id: "In honor of", label: "In honor of" },
                  { id: "In memory of", label: "In memory of" },
                ]}
                isLoading={loading}
                styles={colourStyles}
                onChange={(value) => {
                  formik.setFieldValue(`values.${index}.tribute_type`,  {
                    id: value.id,
                    name: value.label,
                  });
                }}
                value={
                  formik?.values?.values?.[index]?.tribute_type
                    ? {
                      label: formik.values.values?.[index]?.tribute_type?.name,
                      value: formik.values.values?.[index]?.tribute_type?.id,
                    }
                    : payNowValueData?.tribute_info
                      ? {
                        label: payNowValueData?.tribute_info?.type,
                        value: payNowValueData?.tribute_info?.type,
                      }
                      : ""
                }
                components={{ DropdownIndicator }}
              />
            </Col>
            <Col className="col-md-6">
              <InputField
                {...{
                  formik,
                  title: "Name",
                  name: "donor_name",
                  placeholder: "",
                  mandatory: true,
                }}
                value={
                  formik?.values?.values?.[index]?.donor_name
                    ? formik?.values?.values?.[index]?.donor_name
                    : payNowValueData?.tribute_info
                      ? payNowValueData?.tribute_info.donor_name
                      : ""
                }
                handleChange={(event) => {
                  const {value} = event.target;
                  formik.setFieldValue(`values.${index}.donor_name`, value);
                }}
              />
            </Col>
          </Row>
          <Row className="form-row sm-12">
          <Col className="col-12 col-md-12 ">
            <TextareaField
              {...{
                formik,
                rows: 4,
                title: "Tribute Message",
                name: `values.${index}.message`, 
                placeholder: "Tribute text",
                style: { resize: "none" },
                value: `${formik.values?.values?.[index]?.message
                  ? formik.values?.values?.[index]?.message
                  : payNowValueData?.tribute_info
                    ? payNowValueData?.tribute_info?.message
                    : ""}`
              }}
              onChange={(value) => {
                formik.setFieldValue(`values.${index}.message`, value);
              }}
            />
          </Col>
          </Row>
          <div>
          <Row className="form-row sm-12">
            <Col className="col-12 col-md-12 send-acknowledgement-email">
              <MyCheckbox
                title="Send acknowledgement email to"
                checked={formik.values?.values?.[index]?.showAcknowledgement}
                handlechange={(event) => {
                  formik.setFieldValue(
                    `values.${index}.showAcknowledgement`,
                    !formik.values?.values?.[index]?.showAcknowledgement
                  );
                  if(!formik.values?.values?.[index]?.acknowledgements || formik.values?.values?.[index]?.acknowledgements.length === 0){
                    formik.setFieldValue(`values.${index}.acknowledgements`, [{
                      recipient_name: "",
                      email: "",
                    }]);
                  }
                }}
              />
            </Col>
          </Row>
          {formik.values?.values?.[index]?.showAcknowledgement && (
          <div>
            {formik?.values?.values?.[index]?.acknowledgements?.map((acknowledgement, acknowledgementIndex) => (
              <Row className="form-row sm-12 mt-3 flex-nowrap" key={acknowledgementIndex}>
                <Col className="col-12 col-md-6">
                  <InputField
                    {...{
                      formik,
                      title: "Donation Recipient Name",
                      name: "recipient_name",
                      placeholder: "",
                      mandatory: true,
                    }}
                    value={
                      formik?.values?.values?.[index]?.acknowledgements?.[acknowledgementIndex]?.recipient_name
                      ? formik.values?.values?.[index]?.acknowledgements?.[acknowledgementIndex]?.recipient_name
                      : payNowValueData?.tribute_info
                        ? payNowValueData?.tribute_info?.acknowledgements?.[acknowledgementIndex]?.name
                        : ""
                    }
                    handleChange={(event) => {
                      const {value} = event.target;
                      formik.setFieldValue(`values.${index}.acknowledgements.${acknowledgementIndex}.recipient_name`, value);
                    }}
                  />
                </Col>
                <Col className="col-12 col-md-6 tribute-text">
                  <InputField
                    {...{
                      formik,
                      title: "Email",
                      name: "email",
                      placeholder: "",
                      mandatory: true,
                    }}
                    value={
                      formik?.values?.values?.[index]?.acknowledgements?.[acknowledgementIndex]?.email
                        ? formik?.values?.values?.[index]?.acknowledgements?.[acknowledgementIndex]?.email
                        : payNowValueData?.tribute_info
                          ? payNowValueData?.tribute_info?.acknowledgements?.[acknowledgementIndex]?.email
                          : ""
                    }
                    handleChange={(event) => {
                      const {value} = event.target;
                      formik.setFieldValue(`values.${index}.acknowledgements.${acknowledgementIndex}.email`, value);
                    }}
                  />
                </Col>
                {formik.values?.values?.[index]?.acknowledgements?.length > 1 && (
                  <div
                    className="delete_donation_recipient"
                    onClick={() => deleteRecipientHandler(acknowledgementIndex)}
                  >
                    <BackSvgComponent />
                  </div>
                )}
              </Row>
            ))}
           <Row className="form-row sm-12 ">
              <Col className="col-12 mt-5">
                <div className="addRecipient" onClick={addRecipientHandler}>
                  + Add Recipient
                </div>
              </Col>
            </Row>
            </div>
          )}
          </div>
        </div>
      </form>
    </div>
  );
};

export default TributeInformation;
